module.exports = __webpack_public_path__ + "img/all-right.179c95d6.svg";